import React from 'react'
import { Outlet } from "react-router-dom";
import Header from "./Header"
import Sidebar from "./Sidebar"
import '../admin-ui.css';

const AdminLayout = () => {
    return ( 
        <>
            <Header/>
            <Sidebar/>
            <main className='main' id="main">
                <Outlet/>
            </main>
        </>
     );
}
  
export default AdminLayout;